import type { HttpClient } from '../http/HttpClient'
import type {
  BulkReviewDecision,
  BulkReviewItem,
  BulkReviewResult,
  RequestBulkReviewRepository,
} from '@/domain/requestReview/RequestBulkReviewRepository'

interface RawBulkReviewResultRow {
  request_id: number
  result: 'approved' | 'rejected' | 'skipped'
  reason?: string | null
}

interface RawBulkReviewResponse {
  summary: { requested: number; processed: number; skipped: number }
  results: RawBulkReviewResultRow[]
}

export class HttpRequestBulkReviewRepository implements RequestBulkReviewRepository {
  constructor(private http: HttpClient) {}

  async reviewBulk(
    items: BulkReviewItem[],
    decision: BulkReviewDecision,
    comments: string,
  ): Promise<BulkReviewResult> {
    const raw = await this.http
      .url('purchases/requests/bulk-review')
      .body({
        items: items.map((item) => ({ request_id: Number(item.requestId), node_id: item.nodeId })),
        decision,
        comments,
      })
      .post<RawBulkReviewResponse>()

    return {
      summary: raw.summary,
      results: raw.results.map((row) => ({
        requestId: String(row.request_id),
        result: row.result,
        reason: row.reason ?? null,
      })),
    }
  }
}
